import {React,useState, useContext } from "react";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import StoreContext from "./../Componentes/Store/Context";
import { Col,Row, Label, Container } from "reactstrap";
import moment from "moment";
import $ from "jquery";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
import {
  MaterialReactTable,
  MRT_EditActionButtons as MrtEditActionButtons,
} from "material-react-table";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import DeleteIcon from "@mui/icons-material/Delete";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AddBoxIcon from "@mui/icons-material/AddBox";
import CachedIcon from "@mui/icons-material/Cached";
import EditIcon from "@mui/icons-material/Edit";
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import SearchIcon from "@mui/icons-material/Search";
import { imgURLocalImage } from "../Componentes/Services";
import { ADD_IMAGE, BARCODE_IMAGE, SEARCH_IMAGE,EXIT_IMAGE } from "./Image";
import { STATES_DC_COMPRA, STATES_MOV_MOVIMIENTO, STATES_RE_RECUENTO } from "./States";
import {
  COLUMNS_GAS_GASTOS,
  COLUMNS_LISTA_ORDENES_NORMAL,
  COLUMNS_LISTA_ORDENES,
  COLUMNS_ORDENES_DETALLE_RESTAURANTE,
  COLUMNS_CREDITOS_PAGO,
  COLUMNS_CREDITOS,
  COLUMNS_LISTA_CREDITOS_PAGO,
  COLUMNS_LISTA_CREDITOS_DETALLE,
  COLUMNS_LISTA_CREDITOS,
  COLUMNS_RE_RECUENTO_DETALLE,
  COLUMNS_LISTA_COTIZACION,
  COLUMNS_LISTA_FPAGO,
  COLUMNS_LISTA_ANULACION,
  COLUMNS_DC_COMPRA_DETALLE,
  COLUMNS_RE_CUENTO,
  COLUMNS_DC_COMPRA,
  COLUMNS_ARTICULOS,
  COLUMNS_AP_APARTADO,
  COLUMNS_CATEGORIAS,
  COLUMNS_USUARIOS,
  COLUMNS_MARCAS,
  COLUMNS_PROVEEDORES,
  COLUMNS_CLIENTES,
  COLUMNS_BODEGA,
  COLUMNS_FAC_FACTURA_DETALLE,
  COLUMNS_COT_COTIZACION,
  COLUMNS_LISTA_CLIENTE,
  COLUMNS_LISTA_ITEMS,
  COLUMNS_COTD_COOTIZACION_DETALLE,
  COLUMNS_GARANTIA,
  COLUMNS_DESCUENTO,
  COLUMNS_PUBLICIDAD,
  COLUMNS_FAC_FACTURA_DETALLE_ENABLE_ONLY_DESCUENTO,
  COLUMNS_EXISTENCIA_INVENTARIO,
  COLUMNS_TRAZABILIDAD,
  COLUMNS_MOV_MOVIMIENTO,
  COLUMNS_MOVD_MOVIMIENTO_DETALLE,
  COLUMNS_LISTA_ITEMS_BODEGA,
  COLUMNS_CLIENTES_HISTORIAL,
  COLUMNS_SALIDA_VENTA,
  COLUMNS_ENTRADA_INVENTARIO,
  COLUMNS_ENTRADA_FACTURA_COMPRA,
} from "../Componentes/DatatableColumns";
import { MDBIcon } from "mdb-react-ui-kit";

function DATATABLE_FACTURA({
  deleteRow,
  handleSaveRow,
  dataFacturaDetalle,
  enableTab,
  usr_precio,
  isRestaurant,
  dataDescuento,
  setDescuento,
  usr_perfil,
}) {

  return (
    <MaterialReactTable
      initialState={{
        columnVisibility: { fcd_descuento_number: false,
          art_descripcion:window.innerWidth<=611?false:true,
          fcd_precio:window.innerWidth<=611?false:true,
          fcd_cantidad:window.innerWidth<=611?false:true,
          fcd_descuento:window.innerWidth<=611?false:true,

         },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: window.innerWidth <= 370?80:70,
          maxSize: window.innerWidth <= 370?80:70,
          minSize: window.innerWidth <= 370?80:70,
          muiTableBodyCellProps: {
            sx: {
              display: "flex",
              justifyContent: "center",
              // width:"70px",
              alignItems: "center",
              "& button": {
                marginX:  window.innerWidth <= 430 ? "5px" : "1px", 
              },
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={false}
      enableTopToolbar={false}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={false}
      enableSorting={false}
      enableFilters={false}
      muiTableContainerProps={{ sx: { maxHeight: isRestaurant ? "18dvh" :window.innerWidth<=611?"48dvh" :"57dvh" } }}// tablet en 50
      enableStickyHeader={true}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderEmptyRowsFallback={() => (
        <Container fluid>
        <Row>
        <Col xs={12} className="col-no-record label-no-record-fiscal">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
        </Row>
        </Container>
      )}
      columns={usr_perfil === "4"?COLUMNS_FAC_FACTURA_DETALLE_ENABLE_ONLY_DESCUENTO(usr_precio,usr_perfil):COLUMNS_FAC_FACTURA_DETALLE(usr_precio,usr_perfil)}
      onEditingRowSave={handleSaveRow}
      data={enableTab ? [] : dataFacturaDetalle}
      renderEditRowDialogContent={({ table, row, internalEditComponents }) => (
        <>
          <DialogTitle variant="h5">Editar fila</DialogTitle>
          <DialogContent sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
            {internalEditComponents} {/* or render custom edit components here */}
          </DialogContent>
          <DialogActions>
            <MrtEditActionButtons variant="icon" table={table} row={row} />
          </DialogActions>
        </>
      )}
      renderRowActions={({ cell, row, table }) => (
        <Box className="d-flex">
          {usr_perfil === "4" ? (
            <>
              <IconButton aria-label="Eliminar">
                <EditIcon  onClick={() => table.setEditingRow(row)}/>
              </IconButton >
              <IconButton disabled={true} aria-label="Eliminar">
                <DeleteIcon/>
              </IconButton>
            </>
          ) : (
            <>
              <IconButton onClick={() => table.setEditingRow(row)} >
                <EditIcon  />
              </IconButton>
              <IconButton onClick={() => deleteRow(row)} >
                <DeleteIcon />
              </IconButton>
            </>
          )}
        </Box>
      )}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? window.innerWidth<=611?"#f0f0f0":"#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          align:
            cell.column.id === "mrt-row-actions" ||
            cell.column.id === "fcd_precio" ||
            cell.column.id === "fcd_cantidad" ||
            cell.column.id === "fcd_itbms" ||
            cell.column.id === "fcd_total"
              ? "center"
              : "left",
        };
      }}
    />
  );
}
function DATATABLE_RESTAURANTE({
  deleteRow,
  handleSaveRow,
  dataOrdenes,
  enableTab,
  usr_precio,
  isRestaurant,
  isEditing,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={false}
      enableTopToolbar={false}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={false}
      enableSorting={false}
      enableFilters={false}
      muiTableContainerProps={{ sx: { maxHeight: isRestaurant ? "18dvh" : "57dvh" } }}
      enableStickyHeader={true}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      columns={COLUMNS_ORDENES_DETALLE_RESTAURANTE(usr_precio)}
      onEditingRowSave={handleSaveRow}
      data={enableTab ? [] : dataOrdenes}
      renderRowActions={({ row, table }) => {
        if (isEditing) {
          return (
            <Box>
              <IconButton disabled={true}>
                <EditIcon />
              </IconButton>
              <IconButton disabled={true}>
                <DeleteIcon />
              </IconButton>
            </Box>
          );
        } else {
          return (
            <Box>
              <IconButton onClick={() => table.setEditingRow(row)}>
                <EditIcon />
              </IconButton>
              <IconButton onClick={() => deleteRow(row)}>
                <DeleteIcon />
              </IconButton>
            </Box>
          );
        }
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor:
              row.original.ordd_entregado === "0" ? "lightskyblue" : "#f0f0f0",
          },
        };
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            fontWeight:
              cell.column.id === "mrt-row-actions" || cell.column.id === "ordd_total"
                ? "bold"
                : "normal",
            fontSize:
              cell.column.id === "mrt-row-actions" || cell.column.id === "art_descripcion"
                ? "12px"
                : "14px",
            textAlign:
              cell.column.id === "mrt-row-actions" ||
              cell.column.id === "ordd_precio" ||
              cell.column.id === "ordd_cantidad" ||
              cell.column.id === "ordd_total"
                ? "center"
                : "left",
          },
        };
      }}
    />
  );
}

function DATATABLE_EXSITENCIA_INVENTARIO({dataExistenciaInv}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize:  window.innerHeight>=1000?35: 20, pageIndex: 0 },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={false}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: window.innerHeight>=1000?"70dvh": "65dvh"  } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_EXISTENCIA_INVENTARIO()}
      data={dataExistenciaInv}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
    />
  );
}

function DATATABLE_COTIZACION_DETALLE({
  enableTab,
  selectItem,
  deleteRow,
  OBJCotizacionDetalle,
  handleSaveRow,
  usr_precio,
  viewImage,
}) {
  return (
    <MaterialReactTable
      muiTableContainerProps={{ sx: { maxHeight:window.innerWidth <= 1290? window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "40dvh":"47dvh":"56dvh" : "42dvh":"56dvh"} }}//370w 420w, 611w, desktop
      initialState={{
         pagination: { pageSize: 30, pageIndex: 0 },
        columnVisibility: {
          art_descripcion: window.innerWidth >= 611 ? true : false,
          cotd_precio: window.innerWidth <= 611 ? false : true,
          cotd_cantidad: window.innerWidth <= 611 ? false : true,
          cotd_descuento: window.innerWidth <= 611 ? false : true,
          cotd_descuento_number: window.innerWidth <= 611 ? false : true,
        },
      }}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: window.innerWidth <= 370?75:75,
          maxSize: window.innerWidth <= 370?75:75,
          minSize: window.innerWidth <= 370?75:75,
          muiTableBodyCellProps: {
            sx: {
              // display: "flex",
              justifyContent: "center",
              width:"75px",
              alignItems: "center",
              "& button": {
                marginX:  window.innerWidth <= 430 ? "3px" : "9px", 
              },
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}

      renderEditRowDialogContent={({ table, row, internalEditComponents }) => (
        <>
          <DialogTitle variant="h5">Editar fila</DialogTitle>
          <DialogContent sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
            {internalEditComponents} {/* or render custom edit components here */}
          </DialogContent>
          <DialogActions>
            <MrtEditActionButtons variant="icon" table={table} row={row} />
          </DialogActions>
        </>
      )}
      paginationDisplayMode="default"
      globalFilterFn="contains"
      layoutMode="semantic"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={false}
      enableTopToolbar={false}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      onEditingRowSave={handleSaveRow}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_COTD_COOTIZACION_DETALLE(usr_precio)}
      data={enableTab ? [] : OBJCotizacionDetalle}

      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign:
              cell.column.id === "mrt-row-actions" ||
              cell.column.id === "art_upc" ||
              cell.column.id === "cotd_precio" ||
              cell.column.id === "cotd_cantidad" ||
              cell.column.id === "cotd_itbms" ||
              cell.column.id === "cotd_total"
                ? "center"
                : "left",
          },
        };
      }}
      renderRowActions={({ row, table }) => {
        return (

                     <Box className="d-flex">
          <IconButton onClick={() => table.setEditingRow(row)}>
          <EditIcon />
          </IconButton>

          <IconButton onClick={() => deleteRow(row)}>
          <DeleteIcon />
          </IconButton>

          {row.original.art_img === "1" && (
          <img
            className="img-art-datatable"
            alt=""
            onClick={() => viewImage({ row: row.original })}
            src={imgURLocalImage + row.original.art_imgName}
          />
          )}
          </Box>


        );
      }}
    />
  );
}
function DATATABLE_BODEGAS({
  dataBodegas,
  setBasicModalDelete,
  setFormBodegas,
  setBasicModal,
  setBasicModalEdit,
  setError,
  fetchBodega,
  setBodegaPrincipal
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 10, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: "74dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_BODEGA}
      data={dataBodegas}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign:
              cell.column.id === "mrt-row-actions" || cell.column.id === "bod_ubicacion"
                ? "center"
                : "left",
          },
        };
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-130px mx-auto">
            {row.original.bod_primary !=="1"&&             <IconButton
              color="error"
              onClick={() => {
                setBasicModalDelete(true);
                setFormBodegas(row.original);
                setError("");
              }}
            >
              <DeleteIcon />
            </IconButton>}

            <IconButton
              onClick={() => {
                setBasicModal(true);
                setFormBodegas(row.original);
                setBasicModalEdit(true);
                setError("");
              }}
            >
              <EditIcon />
            </IconButton>
            {row.original.bod_primary==="1"?<IconButton>
            <RadioButtonCheckedIcon/>
            </IconButton>:<IconButton
              onClick={() => {
                setBodegaPrincipal(row.original)
                setError("");
              }}>
            <RadioButtonUncheckedIcon/>
            </IconButton>}
            
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton>
            <AddBoxIcon
              onClick={() => {
                setBasicModal(true);
                setFormBodegas({
                  bod_id: "",
                  bod_nombre: "",
                  bod_ubicacion: "",
                  bod_sts: "",
                });
                setBasicModalEdit(false);
                setError("");
              }}
            />
          </IconButton>
          <IconButton>
            <CachedIcon onClick={() => fetchBodega()} />
          </IconButton>
        </Box>
      )}
    />
  );
}

function DATATABLE_CLIENTES_HISTORIAL({dataHistorialClientes}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 10, pageIndex: 0 },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={false}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: "60dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_CLIENTES_HISTORIAL}
      data={dataHistorialClientes}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign:
              cell.column.id === "mrt-row-actions" ||
              cell.column.id === "cli_telefono" ||
              cell.column.id === "cli_ruc" ||
              cell.column.id === "cli_limitc"
                ? "center"
                : "center",
          },
        };
      }}
    />
  );
}
function DATATABLE_CLIENTES_REPORTE({
  dataClientes,
  setFormClientes,
  find_historial,
  setHistorialClientes
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 10, pageIndex: 0 },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: "60dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_CLIENTES}
      data={dataClientes}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign:
              cell.column.id === "mrt-row-actions" ||
              cell.column.id === "cli_telefono" ||
              cell.column.id === "cli_ruc" ||
              cell.column.id === "cli_limitc"
                ? "center"
                : "center",
          },
        };
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      renderRowActions={({ row }) => {
        if (row.original.cli_id !== "16") {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                // color="error"
                onClick={() => {
                  // setBasicModalDelete(true);
                  setFormClientes(row.original);
                  find_historial(row.original.cli_id)
                  setHistorialClientes(true);
                }}
              >
                <SearchIcon />
              </IconButton>
            </Box>
          );
        }
      }}
    />
  );
}
function DATATABLE_CLIENTES({
  dataClientes,
  setBasicModalDelete,
  setFormClientes,
  setBasicModal,
  setBasicModalEdit,
  setError,
  fetchCliente,
  isLoadingC,
  handleExportDataCli,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 10, pageIndex: 0 },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      state={{ isLoading: isLoadingC }}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: "70dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_CLIENTES}
      data={dataClientes}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign:
              cell.column.id === "mrt-row-actions" ||
              cell.column.id === "cli_telefono" ||
              cell.column.id === "cli_ruc" ||
              cell.column.id === "cli_limitc"
                ? "center"
                : "center",
          },
        };
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      renderRowActions={({ row }) => {
        if (row.original.cli_id !== "16") {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                color="error"
                onClick={() => {
                  setBasicModalDelete(true);
                  setFormClientes(row.original);
                  setError("");
                }}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  setBasicModal(true);
                  setFormClientes(row.original);
                  setBasicModalEdit(true);
                  setError("");
                }}
              >
                <EditIcon />
              </IconButton>
            </Box>
          );
        } else {
          return (
            <Box className="w-90px mx-auto">
              <IconButton disabled={true}>
                <DeleteIcon />
              </IconButton>
              <IconButton disabled={true}>
                <EditIcon />
              </IconButton>
            </Box>
          );
        }
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setBasicModal(true);
              setFormClientes({
                cli_id: "",
                cli_suc: "",
                cli_sts: "",
                cli_nombre: "",
                cli_direccion: "",
                cli_telefono: "",
                cli_telefono2: "",
                cli_ruc: "",
                cli_dv: "",
                cli_limitc: "",
                cli_credito: "",
                cli_email: "",
                re_id:"",
                re_desc:"",
                re_porc:"",
                re_codigo:""
              });
              setBasicModalEdit(false);
              setError("");
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchCliente()}>
            <CachedIcon />
          </IconButton>
          <Button
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={handleExportDataCli}
            startIcon={<FileDownloadIcon />}
          >
            CSV
          </Button>
        </Box>
      )}
    />
  );
}
function DATATABLE_PROVEEDORES({
  dataProveedores,
  setBasicModalDelete,
  setFormProveedores,
  setBasicModal,
  setBasicModalEdit,
  setError,
  fetchProveedores,
  isLoadingP,
  handleExportData,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize:  window.innerHeight>=1000?30: 10, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      state={{ isLoading: isLoadingP }}
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: window.innerHeight>=1000?"85dvh": "70dvh"  } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_PROVEEDORES}
      data={dataProveedores}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign:
              cell.column.id === "mrt-row-actions" ||
              cell.column.id === "prov_ruc" ||
              cell.column.id === "prov_telefono"
                ? "center"
                : "left",
          },
        };
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-90px mx-auto">
            <IconButton
              color="error"
              onClick={() => {
                setBasicModalDelete(true);
                setFormProveedores(row.original);
                setError("");
              }}
            >
              <DeleteIcon />
            </IconButton>
            <IconButton
              onClick={() => {
                setBasicModal(true);
                setFormProveedores(row.original);
                setBasicModalEdit(true);
                setError("");
              }}
            >
              <EditIcon />
            </IconButton>
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setBasicModal(true);
              setFormProveedores({
                prov_id: "",
                prov_suc: "",
                prov_nombre: "",
                prov_direccion: "",
                prov_telefono: "",
                prov_ruc: "",
                prov_dv: "",
                prov_sts: "",
                prov_email: "",
              });
              setBasicModalEdit(false);
              setError("");
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchProveedores()}>
            <CachedIcon />
          </IconButton>
          <Button
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={handleExportData}
            startIcon={<FileDownloadIcon />}
          >
            CSV
          </Button>
        </Box>
      )}
    />
  );
}
function DATATABLE_DESCUENTO({
  dataDescuento,
  setBasicModalDelete,
  setFormDescuento,
  setBasicModal,
  setBasicModalEdit,
  setError,
  fetchDescuento,
  isLoadingG,
  setLoadingDes,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 30, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      state={{ isLoading: isLoadingG }}
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: "74dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_DESCUENTO}
      data={dataDescuento}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      renderRowActions={({ row }) => {
        if (row.original.gr_id !== "1") {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                color="error"
                onClick={() => {
                  setBasicModalDelete(true);
                  setFormDescuento(row.original);
                  setError("");
                }}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  setBasicModal(true);
                  setFormDescuento(row.original);
                  setBasicModalEdit(true);
                  setError("");
                }}
              >
                <EditIcon />
              </IconButton>
            </Box>
          );
        } else {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                onClick={() => {
                  setBasicModal(true);
                  setFormDescuento(row.original);
                  setBasicModalEdit(true);
                  setError("");
                }}
              >
                <EditIcon />
              </IconButton>
            </Box>
          );
        }
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setLoadingDes(false);
              setBasicModal(true);
              setFormDescuento({
                gr_id: "",
                gr_name: "",
                gr_descripcion: "",
                gr_sts: "",
              });
              setError("");
              setBasicModalEdit(false);
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchDescuento()}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}

function DATATABLE_GASTOS({dataGastos,setBasicModalDelete,setFormGastos,setBasicModal,setBasicModalEdit,setError,fetchGastos,isLoadingG,setImages,setValueSelected,handleExportData,descargar_zip}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize:  window.innerHeight>=1000?30: 10, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      state={{ isLoading: isLoadingG }}
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: window.innerHeight>=1000?"85dvh": "74dvh"  } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_GAS_GASTOS}
      data={dataGastos}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      renderRowActions={({ row }) => {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                color="error"
                onClick={() => {
                  setBasicModalDelete(true);
                  setFormGastos(row.original);
                  setError("");
                }}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  setBasicModal(true);
                  setImages([]);
                  setFormGastos(row.original);
                  setBasicModalEdit(true);
                  setValueSelected(row.original.tgs_desc)
                  setError("");
                }}
              >
                <EditIcon />
              </IconButton>
            </Box>
          );

      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setImages([]);
              setBasicModal(true);
              setFormGastos({
                gs_id: "",
                gs_suc: "",
                gs_desc: "",
                gs_tipo: "",
                gs_imgType:"",
                gs_fecha: moment(new Date()).format("YYYY-MM-DD"),
                gs_file: "",
                tgs_desc: "",
                gs_sts: "",
              });
              setError("");
              setBasicModalEdit(false);
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton>
          <Button
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={handleExportData}
            startIcon={<FileDownloadIcon />}>
            CSV
          </Button>
          </IconButton>
          <IconButton>
          <Button
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={descargar_zip}
            startIcon={<FileDownloadIcon />}>
            ZIP
          </Button>
          </IconButton>
          <IconButton onClick={() => fetchGastos({date:moment(new Date()).format("YYYY-MM-DD")})}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_GARANTIA({
  dataGarantia,
  setBasicModalDelete,
  setFormGarantia,
  setBasicModal,
  setBasicModalEdit,
  setError,
  fetchGarantia,
  isLoadingG,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize:  window.innerHeight>=1000?30: 10, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      state={{ isLoading: isLoadingG }}
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: window.innerHeight>=1000?"85dvh": "74dvh"  } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_GARANTIA}
      data={dataGarantia}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      renderRowActions={({ row }) => {
        if (row.original.gr_id !== "1") {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                color="error"
                onClick={() => {
                  setBasicModalDelete(true);
                  setFormGarantia(row.original);
                  setError("");
                }}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  setBasicModal(true);
                  setFormGarantia(row.original);
                  setBasicModalEdit(true);
                  setError("");
                }}
              >
                <EditIcon />
              </IconButton>
            </Box>
          );
        } else {
          return (
            <Box className="w-90px mx-auto">
              <IconButton
                onClick={() => {
                  setBasicModal(true);
                  setFormGarantia(row.original);
                  setBasicModalEdit(true);
                  setError("");
                }}
              >
                <EditIcon />
              </IconButton>
            </Box>
          );
        }
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setBasicModal(true);
              setFormGarantia({
                gr_id: "",
                gr_name: "",
                gr_descripcion: "",
                gr_sts: "",
              });
              setError("");
              setBasicModalEdit(false);
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchGarantia()}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_MARCAS({
  dataMarcas,
  setBasicModalDelete,
  setFormMarcas,
  setBasicModal,
  setBasicModalEdit,
  setError,
  fetchMarcas,
  isLoadingM,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
         labelRowsPerPage: "You custom text",
        pagination: { pageSize: window.innerHeight>=1000?30: 10, pageIndex: 0,
           labelRowsPerPage: "You custom text",
         },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      state={{ isLoading: isLoadingM }}
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
           muiTableContainerProps={{ sx: { maxHeight: window.innerHeight>=1000?"85dvh": "74dvh"  } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_MARCAS}
      data={dataMarcas}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign:
              cell.column.id === "mrt-row-actions" ||
              cell.column.id === "prov_ruc" ||
              cell.column.id === "prov_telefono"
                ? "center"
                : "left",
          },
        };
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-90px mx-auto">
            <IconButton
              color="error"
              onClick={() => {
                setBasicModalDelete(true);
                setFormMarcas(row.original);
                setError("");
              }}
            >
              <DeleteIcon />
            </IconButton>
            <IconButton
              onClick={() => {
                setBasicModal(true);
                setFormMarcas(row.original);
                setBasicModalEdit(true);
                setError("");
              }}
            >
              <EditIcon />
            </IconButton>
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setBasicModal(true);
              setFormMarcas({
                mar_id: "",
                mar_descripcion: "",
                mar_sts: "",
              });
              setError("");
              setBasicModalEdit(false);
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchMarcas()}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_CATEGORIAS({
  dataCategorias,
  setBasicModalDelete,
  setFormCategorias,
  setBasicModal,
  setBasicModalEdit,
  setError,
  fetchCategoria,
  isLoadingCa,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: window.innerHeight>=1000?30: 10, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      state={{ isLoading: isLoadingCa }}
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: window.innerHeight>=1000?"85dvh": "74dvh"  } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_CATEGORIAS}
      data={dataCategorias}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="w-90px mx-auto">
            <IconButton
              color="error"
              onClick={() => {
                setBasicModalDelete(true);
                setFormCategorias(row.original);
                setError("");
              }}
            >
              <DeleteIcon />
            </IconButton>
            <IconButton
              onClick={() => {
                setBasicModal(true);
                setFormCategorias(row.original);
                setBasicModalEdit(true);
                setError("");
              }}
            >
              <EditIcon />
            </IconButton>
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setBasicModal(true);
              setFormCategorias({
                cat_id: "",
                cat_descripcion: "",
                cat_sts: "",
              });
              setBasicModalEdit(false);
              setError("");
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchCategoria()}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_APARTADO({
  dataapartado,
  onClickUpdateapartado_sts,
  setFormapartado,
  setBasicModal,
  setBasicModalEdit,
  setOBJapartadoDetalle,
  fetchDCapartadoDetalle,
  setFormapartadoDetalle,
  fetchDCapartado,
  setPrintI,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 50, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: "74dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_AP_APARTADO}
      data={dataapartado}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="width-box-delete mx-auto">
            <IconButton
              color="error"
              onClick={() =>
                onClickUpdateapartado_sts({ ap_id: row.original.ap_id, ap_status: 0 })
              }
            >
              <DeleteIcon />
            </IconButton>
            {row.original.ap_procesado === "1" ? null : (
              <IconButton
                onClick={() => {
                  setBasicModalEdit(true);
                  setBasicModal(true);
                  setFormapartado({
                    ap_id: row.original.ap_id,
                    ap_docn: row.original.ap_docn,
                    ap_identificador: row.original.ap_identificador,
                    ap_proveedor: row.original.ap_proveedor,
                    prov_proveedor: row.original.prov_proveedor,
                    ap_procesado: row.original.ap_procesado,
                    apd_total: row.apd_total,
                    ap_fecha_procesado: row.original.ap_fecha_procesado,
                    ap_fecha: row.original.ap_fecha,
                    ap_descripcion: row.original.ap_descripcion,
                    ap_status: row.original.ap_status,
                  });
                  fetchDCapartadoDetalle(row.original.ap_identificador);
                  setBasicModalEdit(true);
                }}
              >
                <EditIcon />
              </IconButton>
            )}

            <IconButton
              onClick={() => {
                setPrintI(true);
                setFormapartado({
                  ap_id: row.original.ap_id,
                  ap_docn: row.original.ap_docn,
                  ap_identificador: row.original.ap_identificador,
                  ap_proveedor: row.original.ap_proveedor,
                  prov_proveedor: row.original.prov_proveedor,
                  ap_procesado: row.original.ap_procesado,
                  apd_total: row.apd_total,
                  ap_fecha_procesado: row.original.ap_fecha_procesado,
                  ap_fecha: row.original.ap_fecha,
                  ap_descripcion: row.original.ap_descripcion,
                  ap_status: row.original.ap_status,
                });
                fetchDCapartadoDetalle(row.original.ap_identificador);
              }}
            >
              <LocalPrintshopIcon />
            </IconButton>
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setBasicModalEdit(false);
              setBasicModal(true);
              setFormapartado({
                ap_id: "",
                ap_docn: "",
                ap_identificador: moment(new Date()).format("YYYYMMDDHHmmssSSS"),
                ap_suc: "",
                ap_proveedor: "",
                ap_procesado: "",
                apd_total: "",
                prov_proveedor: "",
                ap_fecha_procesado: "",
                ap_fecha: moment(new Date()).format("YYYY-MM-DD"),
                ap_descripcion: "",
                ap_status: "",
              });
              setFormapartadoDetalle({
                apd_id: "",
                apd_articulo: "",
                apd_precio: "",
                apd_cantidad: "1",
                apd_itbms: "",
                apd_descuento: "",
                apd_total: "",
                apd_descuento_number: "",
                art_descripcion: "",
                art_upc: "",
              });
              setOBJapartadoDetalle([]);
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchDCapartado()}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_PUBLICIDAD({
  setImages,
  datapublicidad,
  setFormPublicidad,
  fetchPublicidad,
  removeImage,
  setBasicModal,
  setSrcImage,
  setModalImageTooltip,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 5, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={false}
      enableFullScreenToggle={false}
      muiTableContainerProps={{ sx: { maxHeight: "70dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableToolbarInternalActions={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_PUBLICIDAD(setSrcImage, setModalImageTooltip)}
      data={datapublicidad}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyProps={{
        sx: () => ({
          "& tr:nth-of-type(odd)": {},
        }),
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="width-box-delete-articulos mx-auto d-flex">
            <IconButton
              color="error"
              className="mx-auto"
              onClick={() => {
                removeImage(row.original);
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setBasicModal(true);
              setImages([]);
              setFormPublicidad({
                img_id: "",
                img_name: "",
                img_sts: "",
                img_dataurl: "",
                img_type: "",
              });
            }}>
          <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchPublicidad()}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_ARTICULO({
  usr_perfil,
  dataArticulos,
  setBasicModalDelete,
  setBasicModalEdit,
  setBasicModal,
  setFormArticulos,
  setImages,
  fetchArticulos,
  setFormDropDown,
  setError,
  setDataArticuloBodega,
  setSrcImage,
  setModalImageTooltip,
  setImgName,
  setPrintTooltip,
  handleExportData,
  usr_a_costo
}) {
  const { dataCompania} = useContext(StoreContext);
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "70dvh":"75dvh":"79dvh" : "69dvh" } }}//370w 420w, 611w, desktop
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: window.innerWidth <= 370?55:55,
          maxSize: window.innerWidth <= 370?55:55,
          minSize: window.innerWidth <= 370?55:55,

                    muiTableBodyCellProps: {
            sx: {
              // display: "flex",
              justifyContent: "center",
              width:"55px",
              alignItems: "center",
              "& button": {
                marginX:  window.innerWidth <= 430 ? "3px" : "6px", 
              },
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}


      initialState={{
        pagination: { pageSize: window.innerHeight>=1000?30: 15, pageIndex: 0 },
        columnVisibility: { art_restaurante: dataCompania.com_restaurante==="1"?true:false,art_costo:usr_a_costo==="1"?true:false },
      }}
      globalFilterFn="contains"
      layoutMode="semantic"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      enableGlobalFilter={true}
      positionActionsColumn={ window.innerWidth <= 611?"last":"first"}
      enablePagination={true}
      enableSorting={true}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_ARTICULOS}
      data={dataArticulos}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign: cell.column.id === "art_restaurante" && "center",
          },
        };
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyProps={{
        sx: () => ({
          "& tr:nth-of-type(odd)": {},
        }),
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="d-flex">
            {usr_perfil ==="1"&&<>            <IconButton
              color="error"
              onClick={() => {
                setBasicModalDelete(true);
                setFormArticulos(row.original);
              }}
            >
              <DeleteIcon />
            </IconButton></>}

            <IconButton
              onClick={() => {
                setBasicModal(true);
                setFormArticulos(row.original);
                setImages([]);
                setBasicModalEdit(true);
                setFormDropDown({
                  mar_id: row.original.art_marca,
                  mar_descripcion: row.original.mar_descripcion,
                  cat_id: row.original.art_categoria,
                  cat_descripcion: row.original.cat_descripcion,
                  prov_id: row.original.art_proveedor,
                  prov_nombre: row.original.prov_nombre,
                  itbm_cod_venta: row.original.art_itbm_cod_v,
                  itbm_porc_v: row.original.art_itbm_venta,
                  itbm_cod_compra: row.original.art_itbm_cod_c,
                  itbm_porc_c: row.original.art_itbm_compra,
                  bod_id: row.original.bod_id,
                  bod_nombre: row.original.bod_nombre,
                });
                setError("");
              }}
            >
              <EditIcon />
            </IconButton>
            {window.innerWidth <= 611?null:<img
              src={BARCODE_IMAGE}
              alt=""
              className="img-barcode"
              onClick={() => {
                setPrintTooltip(true);
                setFormArticulos(row.original);
              }}
            />}

            {row.original.art_img === "1" ? (
              <img
                className="img-art-datatable"
                alt=""
                onClick={() => {
                  setFormArticulos(row.original);
                  setImgName(row.original.art_upc);
                  setSrcImage(imgURLocalImage + row.original.art_imgName);
                  setModalImageTooltip(true);
                }}
                src={imgURLocalImage + row.original.art_imgName}
              />
            ) : null}
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setBasicModal(true);
              setDataArticuloBodega([]);
              setPrintTooltip(false);
              setImages([]);
              setBasicModalEdit(false);
              setFormDropDown({
                mar_id: "",
                mar_descripcion: "",
                cat_id: "",
                cat_descripcion: "",
                prov_id: "",
                prov_nombre: "",
                bod_id: "",
                bod_nombre: "",
                itbm_cod_venta: "",
                itbm_porc_v: "",
                itbm_descripcion_venta: "",
                itbm_cod_compra: "",
                itbm_porc_c: "",
                itbm_descripcion_compra: "",
              });
              setFormArticulos({
                art_id: "",
                art_upc: "",
                art_sucursal: "",
                art_categoria: "",
                art_proveedor: "",
                art_marca: "",
                art_descripcion: "",
                art_costo: "",
                art_precio: "",
                art_precio2: "",
                art_precio3: "",
                art_referencia: "",
                art_linea_roja: "0",
                art_img: "",
                art_imgdataurl: "",
                art_imgType: "",
                art_imgName: "",
                art_serie: "",
                art_itbm_venta: "",
                art_itbm_compra: "",
                art_sts: "",
                inv_id: "",
                inv_qty: "",
                art_restaurante: "0",
              });
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchArticulos()}>
            <CachedIcon />
          </IconButton>
          <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
            CSV
          </Button>
        </Box>
      )}
    />
  );
}

// function DATATABLE_DC_COMPRA({
//   dataCompra,
//   setFormCompraDelete,
//   setBasicModalDelete,
//   setBasicModalEdit,
//   setBasicModal,
//   setFormCompra,
//   fetchDCCompraDetalle,
//   setFormDropDownProveedor,
//   setPrintI,
//   setFormProcess,
//   setBasicModalProcesar,
//   fetchDCCompra,
//   setFormCompraDetalle,
//   setOBJCompraDetalle,
// }) {
//   return (
//     <MaterialReactTable
//       paginationDisplayMode="default"
//       initialState={{
//         pagination: { pageSize:{ pageSize: window.innerHeight>=1000?15: 15, pageIndex: 0 }, pageIndex: 0 },
//       }}
//       displayColumnDefOptions={{
//         "mrt-row-actions": {
//           header: "OPCIONES", //change header text
//           muiTableHeadCellProps: {
//             align: "center",
//           },
//         },
//       }}
//       globalFilterFn="contains"
//       layoutMode="semantic"
//       enableEditing={true}
//       enableColumnActions={false}
//       editDisplayMode="modal"
//       enableBottomToolbar={true}
//       enableTopToolbar={true}
//       enableRowActions={true}
//       positionActionsColumn="last"
//       enablePagination={true}
//       enableSorting={false}
//       enableFilters={true}
//       muiTableContainerProps={{ sx: { maxHeight: window.innerHeight>=1000?"82vh": "74vh" } }}
//       muiTableBodyCellProps={({ cell }) => {
//         return {
//           sx: {
//             textAlign:
//               cell.column.id === "mrt-row-actions" ||
//               cell.column.id === "dc_fecha" ||
//               cell.column.id === "dc_fecha_procesado"
//                 ? "center"
//                 : "left",
//           },
//         };
//       }}
//       enableStickyHeader={true}
//       renderEmptyRowsFallback={() => (
//         <Col xs={12} className="col-no-record">
//           <Label className="label-no-record">No hay registros que mostrar</Label>
//         </Col>
//       )}
//       enableFullScreenToggle={false}
//       enableDensityToggle={false}
//       positionGlobalFilter="left"
//       columns={COLUMNS_DC_COMPRA}
//       data={dataCompra}
//       muiSearchTextFieldProps={{
//         placeholder: "Buscar",
//       }}
//       muiTableBodyRowProps={({ row }) => {
//         return {
//           sx: {
//             backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
//           },
//         };
//       }}
//       renderRowActions={({ row }) => {
//         return (
//           <Box className="mx-auto d-flex">
//             <IconButton
//               color="error"
//               onClick={() => {
//                 // onClickUpdateCompra_sts({ dc_id: row.original.dc_id, dc_status: 0 })
//                 setFormCompraDelete({ dc_id: row.original.dc_id, dc_status: 0 });
//                 setBasicModalDelete(true);
//               }}
//             >
//               <DeleteIcon />
//             </IconButton>
//             {row.original.dc_procesado === "1" ? null : (
//               <IconButton
//                 onClick={() => {
//                   setBasicModalEdit(true);
//                   setBasicModal(true);
//                   setFormCompra({
//                     dc_id: row.original.dc_id,
//                     dc_docn: row.original.dc_docn,
//                     dc_identificador: row.original.dc_identificador,
//                     dc_proveedor: row.original.dc_proveedor,
//                     prov_proveedor: row.original.prov_proveedor,
//                     dc_procesado: row.original.dc_procesado,
//                     dcd_total: row.dcd_total,
//                     dc_fecha_procesado: row.original.dc_fecha_procesado,
//                     dc_fecha: row.original.dc_fecha,
//                     dc_descripcion: row.original.dc_descripcion,
//                     dc_status: row.original.dc_status,
//                   });
//                   fetchDCCompraDetalle(row.original.dc_identificador);
//                   setBasicModalEdit(true);
//                   setFormDropDownProveedor({
//                     prov_id: row.original.dc_proveedor,
//                     prov_nombre: row.original.prov_proveedor,
//                   });
//                 }}
//               >
//                 <EditIcon />
//               </IconButton>
//             )}

//             <IconButton
//               onClick={() => {
//                 setPrintI(true);
//                 setFormCompra({
//                   dc_id: row.original.dc_id,
//                   dc_docn: row.original.dc_docn,
//                   dc_identificador: row.original.dc_identificador,
//                   dc_proveedor: row.original.dc_proveedor,
//                   prov_proveedor: row.original.prov_proveedor,
//                   dc_procesado: row.original.dc_procesado,
//                   dcd_total: row.dcd_total,
//                   dc_fecha_procesado: row.original.dc_fecha_procesado,
//                   dc_fecha: row.original.dc_fecha,
//                   dc_descripcion: row.original.dc_descripcion,
//                   dc_status: row.original.dc_status,
//                 });
//                 fetchDCCompraDetalle(row.original.dc_identificador);
//               }}
//             >
//               <LocalPrintshopIcon />
//             </IconButton>
//             {row.original.dc_procesado === "1" ? null : (
//               <IconButton
//                 onClick={() => {
//                   setFormProcess({
//                     dcd_identificador: row.original.dc_identificador,
//                     dc_proveedor: row.original.dc_proveedor,
//                     dc_id: row.original.dc_id,
//                   });
//                   setBasicModalProcesar(true);
//                 }}
//               >
//                 <FlipCameraAndroidIcon />
//               </IconButton>
//             )}
//           </Box>
//         );
//       }}
//       renderTopToolbarCustomActions={({ table }) => (
//         <Box>
//           <IconButton
//             onClick={() => {
//               setBasicModalEdit(false);
//               setBasicModal(true);
//               setFormDropDownProveedor({
//                 prov_id: "",
//                 prov_nombre: "",
//               });
//               setFormCompra(STATES_DC_COMPRA({ staneName: "formCompra" }));
//               setFormCompraDetalle(STATES_DC_COMPRA({ staneName: "formCompraDetalle" }));
//               setOBJCompraDetalle([]);
//             }}
//           >
//             <AddBoxIcon />
//           </IconButton>
//           <IconButton onClick={() => fetchDCCompra()}>
//             <CachedIcon />
//           </IconButton>
//         </Box>
//       )}
//     />
//   );
// }
function DATATABLE_DC_COMPRA({dataCompra,setFormCompraDelete,setBasicModalDelete,setBasicModalEdit,setBasicModal,setFormCompra,fetchDCCompraDetalle,
  setFormDropDownProveedor,setPrintI,setFormProcess,setBasicModalProcesar,fetchDCCompra,setFormCompraDetalle, setOBJCompraDetalle,isLoadingFC}){
  //    const [pagination, setPagination] = useState({  
  //   pageIndex: 0, // 0-based
  //   pageSize: 10,
  // });
  return  <MaterialReactTable
    state={{
      isLoading: isLoadingFC
    }}

          initialState={{
            pagination: { pageSize: window.innerHeight>=1000?30: 15, pageIndex: 0 }
          }}
          displayColumnDefOptions={{
            "mrt-row-actions": {
              header: 'OPCIONES', //change header text
              muiTableHeadCellProps: {
                align: "center",
              }
            },
          }}
          muiPaginationProps={{
            showRowsPerPage: false
          }}
          layoutMode="semantic" 
          enableEditing={true}
          enableColumnActions={false}
          editDisplayMode="modal"
          enableBottomToolbar={true} 
          enableTopToolbar={true}
          enableRowActions={true}
          positionActionsColumn="last"
          enablePagination={true}
          enableSorting={false}
          enableFilters={false} 
          muiTableContainerProps={{ sx: { maxHeight: window.innerHeight>=1000?"85dvh": "74dvh" } }}
          muiTableBodyCellProps={({ cell }) => {
            return {
              sx: {
                fontWeight:cell.column.id==="dc_docn"?"bold":"",
                textAlign: cell.column.id==="mrt-row-actions"|| cell.column.id==="dc_fecha"|| cell.column.id==="dc_fecha_procesado"?"center":"left",  
              }
            };
          }}
          enableStickyHeader={true}
          renderEmptyRowsFallback={() => <Col xs={12} className="col-no-record"><Label className="label-no-record">No hay registros que mostrar</Label></Col>}
          enableFullScreenToggle={false}
          enableDensityToggle={false}
          positionGlobalFilter="left"
          columns={COLUMNS_DC_COMPRA}
          data={dataCompra}
          muiSearchTextFieldProps={{
            placeholder: "Buscar",
          }}
          muiTableBodyRowProps={({ row }) => {
            return {
              sx: {
                backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
              },
            };
          }}
      renderRowActions={({ row }) => {
        return (
          <Box className="mx-auto d-flex">
            {row.original.dc_procesado ==="0"?<IconButton
              color="error"
              onClick={() => {
                setFormCompraDelete({ dc_id: row.original.dc_id, dc_status: 0 });
                setBasicModalDelete(true);
              }}
            >
              <DeleteIcon />
            </IconButton>:null}
            
            {row.original.dc_procesado === "1" ? null : (
              <IconButton
                onClick={() => {
                  setBasicModalEdit(true);
                  setBasicModal(true);
                  setFormCompra({
                    dc_id: row.original.dc_id,
                    dc_docn: row.original.dc_docn,
                    dc_identificador: row.original.dc_identificador,
                    dc_proveedor: row.original.dc_proveedor,
                    prov_proveedor: row.original.prov_proveedor,
                    dc_procesado: row.original.dc_procesado,
                    dcd_total: row.dcd_total,
                    dc_fecha_procesado: row.original.dc_fecha_procesado,
                    dc_fecha: row.original.dc_fecha,
                    dc_descripcion: row.original.dc_descripcion,
                    dc_status: row.original.dc_status,
                    bod_id:row.original.bod_id,
                    bod_nombre:row.original.bod_nombre
                  });
                  fetchDCCompraDetalle(row.original.dc_identificador);
                  setBasicModalEdit(true);
                   setFormCompraDetalle({dcd_id: "",
                    dcd_articulo: "",
                    dcd_precio: "",
                    dcd_cantidad: "1",
                    dcd_itbms: "",
                    dcd_descuento: "",
                    dcd_total: "",
                    dcd_descuento_number: "",
                    art_descripcion: "",
                    art_upc:"",
                    art_itbm_cod_c:"",
                    art_itbm_compra:""});
                  setFormDropDownProveedor({
                    prov_id: row.original.dc_proveedor,
                    prov_nombre: row.original.prov_proveedor,
                    bod_id:row.original.bod_id,
                    bod_nombre:row.original.bod_nombre
                  });
                }}
              >
                <EditIcon />
              </IconButton>
            )}

            <IconButton
              onClick={() => {
                setPrintI(true);
                setFormCompra({
                  dc_id: row.original.dc_id,
                  dc_docn: row.original.dc_docn,
                  dc_identificador: row.original.dc_identificador,
                  dc_proveedor: row.original.dc_proveedor,
                  prov_proveedor: row.original.prov_proveedor,
                  dc_procesado: row.original.dc_procesado,
                  dcd_total: row.dcd_total,
                  dc_fecha_procesado: row.original.dc_fecha_procesado,
                  dc_fecha: row.original.dc_fecha,
                  dc_descripcion: row.original.dc_descripcion,
                  dc_status: row.original.dc_status,
                  bod_id:row.original.bod_id,
                  bod_nombre:row.original.bod_nombre
                });
                fetchDCCompraDetalle(row.original.dc_identificador);
              }}
            >
              <LocalPrintshopIcon />
            </IconButton>
            {row.original.dc_procesado === "1" ? null : (
              <IconButton
                onClick={() => {
                  setFormProcess({
                    dcd_identificador: row.original.dc_identificador,
                    dc_proveedor: row.original.dc_proveedor,
                    dc_id: row.original.dc_id,
                    bod_id: row.original.bod_id
                  });
                  setBasicModalProcesar(true);
                }}
              >
                <FlipCameraAndroidIcon />
              </IconButton>
            )}
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setBasicModalEdit(false);
              setBasicModal(true);
              setFormDropDownProveedor({
                prov_id: "",
                prov_nombre: "",
                bod_id:"",
                bod_nombre:""
              });
              setFormCompra(STATES_DC_COMPRA({ staneName: "formCompra" }));
              setFormCompraDetalle(STATES_DC_COMPRA({ staneName: "formCompraDetalle" }));
              setOBJCompraDetalle([]);
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchDCCompra()}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}

/>
}
function DATATABLE_MOVIMIENTO_INVENTARIO({
  dataMovimiento,
  setFormMovimientoDelete,
  setBasicModalDeleteMov,
  fetchMovimientoDetalle,
  setFormMov,
  setBasicModalMov,
  setBasicModalEditMov,
  setPrintM,
  setFormProcessMov,
  setBasicModalProcesarMov,
  setOBJMovimientoDetalle,
  fetchMovimiento,
  setFormMovimientoDetalle,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: window.innerHeight>=1000?30: 10, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
   
      enableFilters={false}
      muiTableContainerProps={{ sx: { maxHeight: window.innerHeight>=1000?"85dvh": "74dvh"  } }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            fontWeight:cell.column.id==="mov_id"?"bold":"",
            textAlign:
              cell.column.id === "mrt-row-actions" ||
              cell.column.id === "re_fecha" ||
              cell.column.id === "re_fecha_procesado"
                ? "center"
                : "left",
          },
        };
      }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiTableBodyRowProps={({ row }) => {
        return {
         sx: {
                backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
              },
        };
      }}
      columns={COLUMNS_MOV_MOVIMIENTO}
      data={dataMovimiento}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="width-box-delete">
            <IconButton
              color="error"
              onClick={() => {
                setFormMovimientoDelete({ mov_id: row.original.mov_id, mov_sts: 0 });
                setBasicModalDeleteMov(true);
              }}
            >
              <DeleteIcon />
            </IconButton>
            {row.original.mov_procesado === "1" ? null : (
              <IconButton
                onClick={() => {
                  setBasicModalEditMov(true);
                  setBasicModalMov(true);
                  setFormMov({
                  mov_id: row.original.re_id,
                  mov_identificador: row.original.re_identificador,
                  mov_fecha: moment(row.original.re_fecha).format("YYYY-MM-DD"),
                  mov_fecha_procesado: row.original.re_fecha_procesado,
                  mov_procesado: row.original.mov_procesado,
                  mov_bodega_desde: row.original.mov_bodega_desde,
                  mov_bodega_hacia: row.original.mov_bodega_hacia,
                  mov_descripcion: row.original.re_descripcion,
                });
                  fetchMovimientoDetalle({
                    mov_identificador: row.original.mov_identificador,
                  });
                }}
              >
                <EditIcon />
              </IconButton>
            )}

            <IconButton
              onClick={() => {
                setPrintM(true);
                setFormMov({
                  mov_id: row.original.re_id,
                  mov_identificador: row.original.re_identificador,
                  mov_fecha: row.original.re_fecha,
                  mov_fecha_procesado: row.original.re_fecha_procesado,
                  mov_procesado: row.original.mov_procesado,
                  mov_bodega_desde: row.original.mov_bodega_desde,
                  mov_bodega_hacia: row.original.mov_bodega_hacia,
                  mov_descripcion: row.original.re_descripcion,
                });
                fetchMovimientoDetalle({ mov_identificador: row.original.mov_identificador });
              }}
            >
              <LocalPrintshopIcon />
            </IconButton>
            {row.original.mov_procesado === "1" ? null : (
              <IconButton
                onClick={() => {
                  setFormProcessMov({
                    mov_identificador: row.original.mov_identificador,
                    mov_id: row.original.mov_id,
                  });
                  setBasicModalProcesarMov(true);
                }}
              >
                <FlipCameraAndroidIcon />
              </IconButton>
            )}
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setBasicModalEditMov(false);
              setBasicModalMov(true);
              setFormMovimientoDetalle(
                STATES_MOV_MOVIMIENTO({ staneName: "formMovimientoDetalle" })
              );
              setFormMov(STATES_MOV_MOVIMIENTO({ staneName: "formMovimiento" }));
              setOBJMovimientoDetalle([]);
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchMovimiento()}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}


function DATATABLE_LISTA_ITEMS2({ dataItems }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 50, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: "65dvh" } }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign:
              cell.column.id === "mrt-row-actions" ||
              cell.column.id === "re_fecha" ||
              cell.column.id === "re_fecha_procesado"
                ? "center"
                : "left",
          },
        };
      }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor:
              row.original.re_fecha_procesado !== "0000-00-00 00:00:00"
                ? "rgba(219, 237, 220, 0.78)"
                : "",
            fontWeight: "bold",
            height: "60px",
          },
        };
      }}
      columns={COLUMNS_LISTA_ITEMS}
      data={dataItems}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
    />
  );
}
function DATATABLE_DC_COMPRA_DETALLE({
  dataCompraDetalle,
  deleteRow,
  onBlurs,
  enableTab,
  handleSaveRow,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
       pagination: { pageSize: window.innerHeight>=1000?30: 15, pageIndex: 0 }
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      globalFilterFn="contains"
      layoutMode="semantics"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={false}
      enableTopToolbar={false}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={false}
      enableSorting={false}
      enableFilters={false}
      muiTableContainerProps={{ sx: { maxHeight: window.innerHeight>=1000?"58dvh": "37dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyProps={{
        sx: () => ({
          "& tr:nth-of-type(odd)": {},
        }),
      }}
      columns={COLUMNS_DC_COMPRA_DETALLE(deleteRow, onBlurs)}
      onEditingRowSave={handleSaveRow}
      data={enableTab ? [] : dataCompraDetalle}
      renderRowActions={({ row, table }) => (
        <Box>
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
          <IconButton onClick={() => deleteRow(row)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      )}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            fontWeight:cell.column.id==="art_upc"?"bold":"",
          },
        };
      }}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_ITEMS_BODEGA({ dataItems, selectItem, setTabItems,setFormMovimientoDetalle,props,usr_a_costo }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: window.innerHeight>=1000?30: 15, pageIndex: 0 },
        columnVisibility: { art_costo:usr_a_costo==="1"?true:false },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={false}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight:window.innerHeight>=1000?"66dvh": "51dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      enableGlobalFilter={true}
      muiTableBodyRowProps={({ row }) => ({
        sx: {
          backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
        },
        onClick: () => {
          setFormMovimientoDetalle({...props,inv_qty:row.original.inv_qty})
          selectItem({art_upc:row.original.art_upc,inv_qty:row.original.inv_qty});
          setTabItems(false);
        },
      })}
      muiTableBodyRowformFactura={({ row }) => {
        return {
          sx: {
            backgroundColor:
              row.original.re_fecha_procesado !== "0000-00-00 00:00:00"
                ? "rgba(219, 237, 220, 0.78)"
                : "",
            fontWeight: "bold",
          },
        };
      }}
      columns={COLUMNS_LISTA_ITEMS_BODEGA()}
      data={dataItems}
      muiTableContainerformFactura={{
        sx: {
          maxHeight: "290px",
        },
      }}
    />
  );
}

function DATATABLE_COLUMNS_LISTA_ANULACION({
  dataListAnulacion,
  setTabAnular,
  setTabAnularNC,
  setFormAnulacion,
  getDetailItem,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 50, pageIndex: 0 },
      }}
            muiPaginationProps={{
        showRowsPerPage: false
      }}
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={true}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth<=611?"70dvh":"55dvh" } }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      enableGlobalFilter={true}
      muiTableBodyProps={{
        sx: () => ({
          "& tr:nth-of-type(odd)": {},
        }),
      }}
      renderRowActions={({ row,table }) => {
      return <Box className="width-box-delete-opciones mx-auto d-flex">
        <IconButton onClick={()=>{ setTabAnular(false); setFormAnulacion({ ...row.original, motivo_anulacion: "" })}} color="error">
          <DeleteIcon/>
        </IconButton>
        {(row.original.fac_recibo==="1" && row.original.fac_tipodocumento ==="01") && <IconButton onClick={()=>{setTabAnularNC(true); setTabAnular(false);getDetailItem({data:row.original}); setFormAnulacion({ ...row.original, motivo_anulacion: "" })}}  >
          <ReceiptLongIcon/>
        </IconButton>}
        </Box>
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: window.innerWidth <= 370?80:70,
          maxSize: window.innerWidth <= 370?80:70,
          minSize: window.innerWidth <= 370?80:70,
          muiTableBodyCellProps: {
            sx: {
              display: "flex",
              justifyContent: "center",
              // width:"70px",
              alignItems: "center",
              "& button": {
                marginX:  window.innerWidth <= 430 ? "5px" : "1px", 
              },
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          // onClick: () => {
          //   setTabAnular(false);
          //   setFormAnulacion({ ...row.original, motivo_anulacion: "" });
          // },
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
            fontWeight: "bold",
          },
        };
      }}
      columns={COLUMNS_LISTA_ANULACION(setTabAnular, setFormAnulacion)}
      data={dataListAnulacion}
      muiTableContainerformFactura={{
        sx: {
          maxHeight: "290px",
        },
      }}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_FPAGO({ dataListpago, handleSaveRow, deleteRow }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
  muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "30dvh":"325dvh":"35dvh" : "40dvh" } }}//370w 420w, 611w, desktop
      initialState={{
        pagination: { pageSize: 30, pageIndex: 0 },
        columnVisibility: {list_monto:window.innerWidth<=611?false:true,

         },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={false}
      enableTopToolbar={false}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={false}
      enableSorting={false}
      enableFilters={false}
            renderEditRowDialogContent={({ table, row, internalEditComponents }) => (
        <>
          <DialogTitle variant="h5">Editar fila</DialogTitle>
          <DialogContent sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
            {internalEditComponents} {/* or render custom edit components here */}
          </DialogContent>
          <DialogActions>
            <MrtEditActionButtons variant="icon" table={table} row={row} />
          </DialogActions>
        </>
      )}
      columns={COLUMNS_LISTA_FPAGO()}
      onEditingRowSave={handleSaveRow}
      data={dataListpago}
      renderEmptyRowsFallback={() => (

        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      muiTableBodyCellProps={({ cell }) => {
        return {
          fontWeight:cell.column.id==="fac_id"?"bold":"",
          sx: {
            textAlign: "center",
          },
        };
      }}
      renderRowActions={({ row, table }) => (
        <Box>
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
          <IconButton onClick={() => deleteRow(row)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}


function DATATABLE_COLUMNS_LISTA_ORDENES({ selectItemOrdenes, dataListOrdenes,deleteRow }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      state={{
        selectItemOrdenes,
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          onClick: () => {
            selectItemOrdenes({ ordd_identificador: row.original.ord_identificador,ord_mesa:row.original.ord_mesa,res_nombre:row.original.res_nombre });
          },
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
            fontWeight: "bold",
          },
        };
      }}
          renderRowActions={({ row,table }) => {
      return <Box className="width-box-delete-opciones mx-auto d-flex">
        <IconButton onClick={()=>{ selectItemOrdenes({ ordd_identificador: row.original.ord_identificador })}}>
          <AddBoxIcon/>
        </IconButton>
        <IconButton onClick={()=>{deleteRow({row:row.original});}}  color="error">
          <DeleteIcon/>
        </IconButton>
        </Box>
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      muiTableContainerProps={{ sx: { maxHeight: "55dvh" } }}
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={false}
      enableRowActions={false}
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={true}
      columns={COLUMNS_LISTA_ORDENES()}
      data={dataListOrdenes}
    />
  );
}



function DATATABLE_COLUMNS_LISTA_CREDITOS_PAGO({ dataListCreditoPago, deleteRow }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      renderRowActions={({ row, table }) => (
        <Box className="text-center">
          <IconButton onClick={() => deleteRow(row)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      )}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      initialState={{
        pagination: { pageSize: 30, pageIndex: 0 },
      }}
      globalFilterFn="contains"
      muiTableContainerProps={{ sx: { maxHeight: "55dvh" } }}
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={false}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={false}
      enableRowActions={true}
      enablePagination={true}
      enableSorting={false}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFilters={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={false}
      columns={COLUMNS_LISTA_CREDITOS_PAGO()}
      data={dataListCreditoPago}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_CREDITOS_DETALLE({
  selectCreditosPago,
  dataListCreditoDetalle,
  setCreditoPago,
  setCreditoDetalle,
  setFacIdentificador,
  setFormPagoCredito,
  formPagoCredito,
  printFac,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          onClick: () => {
            selectCreditosPago({ crd_fac_identificador: row.original.fac_identificador });
            setFacIdentificador(row.original.fac_identificador);
            setCreditoPago(true);
            setCreditoDetalle(false);
            setFormPagoCredito({
              ...formPagoCredito,
              fac_id: row.original.fac_id.toString().padStart(10, "0"),
              fac_identificador: row.original.fac_identificador,
              crd_fecha: row.original.crd_fecha,
              crd_monto: row.original.crd_monto_c,
              crp_monto: row.original.crp_monto_p,
            });
          },
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
            fontWeight: "bold",
          },
        };
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      muiTableContainerProps={{ sx: { maxHeight: "55dvh" } }}
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={true}
      enableEditing={false}
      enableRowActions={false}
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={true}
      columns={COLUMNS_LISTA_CREDITOS_DETALLE(printFac)}
      data={dataListCreditoDetalle}
    />
  );
}

function DATATABLE_COLUMNS_LISTA_CREDITOS({
  selectCreditosDetalle,
  dataListCreditos,
  setCreditoDetalle,
  setCrpCliente,
  setCliName,
  setMontoAdeudado,
  setFormPagoCredito,
  formPagoCredito,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      initialState={{
        pagination: { pageSize: 20, pageIndex: 0 },
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          onClick: () => {
            selectCreditosDetalle({ crd_cliente: row.original.cli_id });
            setCrpCliente(row.original.cli_id);
            setCreditoDetalle(true);
            setCliName(row.original.cli_nombre);
            setMontoAdeudado(row.original.crd_monto_c);
            setFormPagoCredito({
              ...formPagoCredito,
              cli_name: row.original.cli_nombre,
              cli_telefono: row.original.cli_telefono,
              cli_ruc:
                row.original.cli_dv !== ""
                  ? row.original.cli_ruc + " " + row.original.cli_dv
                  : row.original.cli_ruc,
            });
          },
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
            fontWeight: "bold",
          },
        };
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth<=611?"68dvh":"57dvh"} }}
      enableStickyHeader={false}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={false}
      enableRowActions={false}
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={true}
      columns={COLUMNS_LISTA_CREDITOS()}
      data={dataListCreditos}
    />
  );
}
function DATATABLE_COLUMNS_MOVIMIENTO({
  enableTab,
  dataMovimientoDetalle,
  handleSaveRow,
  deleteRow,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor:
              row.original.dc_fecha_procesado !== "0000-00-00 00:00:00"
                ? "rgba(219, 237, 220, 0.78)"
                : "",
            fontWeight: "bold",
          },
        };
      }}
         renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"  
      muiTableContainerProps={{ sx: { maxHeight: "55dvh" } }}
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={false}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={true}
      enableRowActions={true}
      enablePagination={true}
      enableSorting={false}
      enableFilters={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={false}
      columns={COLUMNS_MOVD_MOVIMIENTO_DETALLE()}
      data={enableTab ? [] : dataMovimientoDetalle}
      onEditingRowSave={handleSaveRow}
      renderRowActions={({ row, table }) => (
        <Box>
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
          <IconButton onClick={() => deleteRow(row)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}


function DATATABLE_CREDITOS({ dataCreditos, handleExportData }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
            CSV
          </Button>
        </Box>
      )}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor:
              row.original.dc_fecha_procesado !== "0000-00-00 00:00:00"
                ? "rgba(219, 237, 220, 0.78)"
                : "",
            fontWeight: "bold",
          },
        };
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      muiTableContainerProps={{ sx: { maxHeight: "55dvh" } }}
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={false}
      enableRowActions={false}
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={true}
      columns={COLUMNS_CREDITOS()}
      data={dataCreditos}
    />
  );
}
function DATATABLE_CREDITOS_PAGO({ handleExportData, dataCreditospago }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
            CSV
          </Button>
        </Box>
      )}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor:
              row.original.dc_fecha_procesado !== "0000-00-00 00:00:00"
                ? "rgba(219, 237, 220, 0.78)"
                : "",
            fontWeight: "bold",
          },
        };
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      muiTableContainerProps={{ sx: { maxHeight: "55dvh" } }}
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={false}
      enableRowActions={true}
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={true}
      columns={COLUMNS_CREDITOS_PAGO()}
      data={dataCreditospago}
    />
  );
}
function DATATABLE_USUARIOS({
  dataUsuarios,
  setBasicModalDelete,
  setFormUsuarios,
  setBasicModal,
  setBasicModalEdit,
  setError,
  fetchUsuarios,
  isLoadingU,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430? "71dvh":"73dvh" : "85dvh" } }}//420w, 611w, desktop
      initialState={{
        pagination: { pageSize: window.innerHeight>=1000?30: 10, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: window.innerWidth <= 370?105:95,
          maxSize: window.innerWidth <= 370?105:95,
          minSize: window.innerWidth <= 370?105:95,
          muiTableBodyCellProps: {
            sx: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      state={{ isLoading: isLoadingU }}
      layoutMode="semantic"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_USUARIOS}
      data={dataUsuarios}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign:
              cell.column.id === "mrt-row-actions" ||
              cell.column.id === "bod_ubicacion" ||
              cell.column.id === "usr_perfil"
                ? "center"
                : "left",
          },
        };
      }}
      renderRowActions={({ row }) => {
        return (
          <Box >
            <IconButton
              onClick={() => {
                setBasicModal(true);
                setFormUsuarios(row.original);
                setBasicModalEdit(true);
                setError("");
              }}
            >
              <EditIcon />
            </IconButton>
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton onClick={() => fetchUsuarios()}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_COTIZACION({
  selectItemCotizacion,
  dataListCotizacion,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      state={{
        selectItemCotizacion,
      }}
            initialState={{
        pagination: { pageSize: 30, pageIndex: 0 },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES", //change header text
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            fontWeight:cell.column.id==="cot_id"?"bold":"",
          },
        };
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          onClick: () => {
            selectItemCotizacion({ cot_identificador: row.original.cot_identificador });
          },
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
            fontWeight: "bold",
          },
        };
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
            renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
            muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      globalFilterFn="contains"
        muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "66dvh":"70dvh":"73dvh" : "57dvh" } }}//370w 420w, 611w, desktop
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={false}
      enableRowActions={false}
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={true}
      columns={COLUMNS_LISTA_COTIZACION()}
      data={dataListCotizacion}
    />
  );
}
function DATATABLE_ENTRADA_FACTURA_COMPRA({dataEntradaFCompra}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430? "71dvh":"73dvh" : "85dvh" } }}//420w, 611w, desktop
      initialState={{
        pagination: { pageSize: window.innerHeight>=1000?30: 15, pageIndex: 0 }
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={false}
      enableRowActions={false}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiTableBodyRowProps={({ row }) => {
        return {
         sx: {
                backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
              },
        };
      }}
      columns={COLUMNS_ENTRADA_FACTURA_COMPRA}
      data={dataEntradaFCompra}
    />
  );
}
function DATATABLE_ENTRADA_INVENTARIO({dataEntradaInventario}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430? "71dvh":"73dvh" : "85dvh" } }}//420w, 611w, desktop
      initialState={{
        pagination: { pageSize: window.innerHeight>=1000?30: 15, pageIndex: 0 }
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={false}
      enableRowActions={false}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiTableBodyRowProps={({ row }) => {
        return {
         sx: {
                backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
              },
        };
      }}
      columns={COLUMNS_ENTRADA_INVENTARIO}
      data={dataEntradaInventario}
    />
  );
}
function DATATABLE_SALIDA_VENTA({dataSalidaVenta}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430? "71dvh":"73dvh" : "85dvh" } }}//420w, 611w, desktop
      initialState={{
        pagination: { pageSize: window.innerHeight>=1000?30: 15, pageIndex: 0 }
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={false}
      enableRowActions={false}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiTableBodyRowProps={({ row }) => {
        return {
         sx: {
                backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
              },
        };
      }}
      columns={COLUMNS_SALIDA_VENTA}
      data={dataSalidaVenta}
    />
  );
}
function DATATABLE_TRAZABILIDAD({dataTrazabilidad,setTabTrazabilidadDetail,fetchTrazabilidadDetallado}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "68dvh":"73dvh":"78dvh" : "85dvh" } }}//370w 420w, 611w, desktop
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: window.innerWidth <= 370?75:55,
          maxSize: window.innerWidth <= 370?75:55,
          minSize: window.innerWidth <= 370?75:55,
          muiTableBodyCellProps: {
            sx: {
              display: "flex",
              justifyContent: "center",
              width:"70px",
              alignItems: "center",
              "& button": {
                marginX:  window.innerWidth <= 430 ? "4px" : "9px", 
              },
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="semantic"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_TRAZABILIDAD}
      data={dataTrazabilidad}
      muiTableBodyRowProps={({ row }) => {
        if (row.original.art_linea_roja !== "0") {
          return {
            sx: {
              backgroundColor: row.original.inv_qty >= row.original.art_linea_roja ? "#f0f0f0" : "#fbd2d2",
            },
          };
        }
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            fontWeight:cell.column.id==="art_upc"?"bold":"",
            textAlign:
              cell.column.id === "mrt-row-actions" ||
              cell.column.id === "art_categoria" ||
              cell.column.id === "art_marca" ||
              cell.column.id === "art_linea_roja" ||
              cell.column.id === "inv_qty"
                ? "center"
                : "left",
          },
        };
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="width-box-deletes">
            {
              <IconButton
                onClick={() => {
                  fetchTrazabilidadDetallado({
                    art_id: row.original.art_id,
                    art_upc:row.original.art_upc,
                    art_descripcion:row.original.art_descripcion
                  });
                  setTabTrazabilidadDetail(true);
                }}
              >
                <SearchIcon />
              </IconButton>
            }
          </Box>
        );
      }}
    />
  );
}
function DATATABLE_LISTA_ITEMS({select_detail_articulo, dataItems, selectItem, setTabItems,usr_a_costo }) {

  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "67dvh":"71dvh":"73dvh" : "65dvh" } }}//370w 420w, 611w, desktop
         initialState={{
            pagination: { pageSize: window.innerHeight>=1000?30: 15, pageIndex: 0 },
            columnVisibility: { art_costo:usr_a_costo==="1"?true:false },
          }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: window.innerWidth <= 370?105:95,
          maxSize: window.innerWidth <= 370?105:95,
          minSize: window.innerWidth <= 370?105:95,
          muiTableBodyCellProps: {
            sx: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}  
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_LISTA_ITEMS()}
      data={dataItems}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row,table }) => {
      return <Box className="width-box-delete-cotizacion mx-auto d-flex">
          <img alt ="" className="img-art-datatable-2" onClick={()=>{ selectItem(row.original.art_upc);  setTabItems(false);} } src ={ADD_IMAGE} />
          <img alt ="" className="img-art-datatable-2" onClick={()=>{select_detail_articulo({row:row.original});}} src ={SEARCH_IMAGE} />
        </Box>
      }}
      muiTableBodyRowformFactura={({ row }) => {
        return {
          sx: {
            backgroundColor:
              row.original.re_fecha_procesado !== "0000-00-00 00:00:00"
                ? "rgba(219, 237, 220, 0.78)"
                : "",
            fontWeight: "bold",
          },
        };
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
    />
  );
}
function DATATABLE_INV_INVENTARIO({
  dataRecuento,
  setFormRecuentoDelete,
  setBasicModalDeleteRe,
  fetchRecuentoDetalle,
  setFormRecuento,
  setBasicModalRe,
  setBasicModalEditRe,
  setPrintI,
  setFormProcessRe,
  setBasicModalProcesarRe,
  setOBJRecuentoDetalle,
  fetchRecuento,
  setFormRecuentoDetalle,
  setFormDropDownInv
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"

      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "38dvh":"71dvh":"73dvh" : "85dvh" } }}//370w 420w, 611w, desktop
         initialState={{
            pagination: { pageSize: window.innerHeight>=1000?30: 15, pageIndex: 0 }
          }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: window.innerWidth <= 370?105:95,
          maxSize: window.innerWidth <= 370?105:95,
          minSize: window.innerWidth <= 370?105:95,
          muiTableBodyCellProps: {
            sx: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}

      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
             fontWeight:cell.column.id==="art_upc"?"bold":"",
            textAlign:
              cell.column.id === "mrt-row-actions" ||
              cell.column.id === "re_fecha" ||
              cell.column.id === "re_fecha_procesado"
                ? "center"
                : "left",
          },
        };
      }}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      muiTableBodyRowProps={({ row }) => {
        return {
         sx: {
                backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
              },
        };
      }}
      columns={COLUMNS_RE_CUENTO}
      data={dataRecuento}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="width-box-delete">
            {row.original.re_procesado ==="0"?<IconButton
              color="error"
              onClick={() => {
                setFormRecuentoDelete({ re_id: row.original.re_id, re_status: 0 });
                setBasicModalDeleteRe(true);
              }}
            >
              <DeleteIcon />
            </IconButton>:null
            }

            {row.original.re_procesado === "1" ? null : (
              <IconButton
                onClick={() => {
                  setBasicModalEditRe(true);
                  setBasicModalRe(true);
                  setFormRecuento({
                    re_id: row.original.re_id,
                    re_identificador: row.original.re_identificador,
                    re_fecha: moment(row.original.re_fecha).format("YYYY-MM-DD"),
                    re_fecha_procesado: row.original.re_fecha_procesado,
                    re_procesado: row.original.re_procesado,
                    re_descripcion: row.original.re_descripcion,
                  });
                  setFormDropDownInv({bod_id:row.original.bod_id,bod_nombre:row.original.bod_nombre})
                  fetchRecuentoDetalle({
                    re_identificador: row.original.re_identificador,
                  });
                }}
              >
                <EditIcon />
              </IconButton>
            )}

            <IconButton
              onClick={() => {
                setPrintI(true);
                setFormRecuento({
                  re_id: row.original.re_id,
                  re_identificador: row.original.re_identificador,
                  re_fecha: row.original.re_fecha,
                  re_fecha_procesado: row.original.re_fecha_procesado,
                  re_procesado: row.original.re_procesado,
                  re_descripcion: row.original.re_descripcion,
                });
                fetchRecuentoDetalle({ re_identificador: row.original.re_identificador }); 
              }}
            >
              <LocalPrintshopIcon />
            </IconButton>
            {row.original.re_procesado === "1" ? null : (
              <IconButton
                onClick={() => {
                  setFormProcessRe({
                    red_identificador: row.original.re_identificador,
                    re_id: row.original.re_id,
                    bod_id:row.original.bod_id,
                    bod_nombre:row.original.bod_nombre
                  });
                  setBasicModalProcesarRe(true);
                }}
              >
                <FlipCameraAndroidIcon />
              </IconButton>
            )}
          </Box>
        );
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              setBasicModalEditRe(false);
              setBasicModalRe(true);
              setFormRecuentoDetalle(
                STATES_RE_RECUENTO({ staneName: "formRecuentoDetalle" })
              );
              setFormRecuento(STATES_RE_RECUENTO({ staneName: "formRecuento" }));
              setOBJRecuentoDetalle([]);
              setFormDropDownInv({bod_id:"",bod_nombre:""})
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetchRecuento()}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_ITEMS({ dataItems, selectItem, setTabItems,select_detail_articulo,usr_a_costo }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "66dvh":"68dvh":"73dvh" : "65dvh" } }}//370w 420w, 611w, desktop
      initialState={{
        pagination: { pageSize: window.innerHeight>=1000?35: 20, pageIndex: 0 },
           columnVisibility: {art_descripcion:window.innerWidth<=611?false:true,
            art_costo:usr_a_costo==="1"?true:false,
            mar_descripcion:window.innerWidth<=611?false:true
           }
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
           renderRowActions={({ row,table }) => {
      return <Box className="width-box-delete-opciones mx-auto d-flex">
              <IconButton onClick={()=>{ selectItem(row.original.art_upc);  setTabItems(false);} }>
                <AddBoxIcon/>
              </IconButton>
              <IconButton onClick={()=>{select_detail_articulo({row:row.original});}} >
                <SearchIcon/>
              </IconButton>

        </Box>
      }}
            muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: 55,
          maxSize: 55,
          minSize: 55,
          muiTableBodyCellProps: {
            sx: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
        

      }}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableGlobalFilter={true}
      muiTableBodyRowProps={({ row}) => ({
        sx: {
          backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
        },
      })}
      
      muiTableBodyRowformFactura={({ row }) => {
        return {
          sx: {
            backgroundColor:
              row.original.re_fecha_procesado !== "0000-00-00 00:00:00"
                ? "rgba(219, 237, 220, 0.78)"
                : "",
            fontWeight: "bold",
          },
        };
      }}
      columns={COLUMNS_LISTA_ITEMS()}
      data={dataItems}
      muiTableContainerformFactura={{
        sx: {
          maxHeight: "290px",
        },
      }}
    />
  );
}
function DATATABLE_COLUMNS_LISTA_ORDENES_NORMAL({ selectItemOrdenes, dataListOrdenes,deleteRow }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      state={{
        selectItemOrdenes,
      }}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
            renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: window.innerWidth <= 370?75:75,
          maxSize: window.innerWidth <= 370?75:75,
          minSize: window.innerWidth <= 370?75:75,
          muiTableBodyCellProps: {
            sx: {
              // display: "flex",
              justifyContent: "center",
              width:"85px",
              alignItems: "center",
              "& button": {
                marginX:  window.innerWidth <= 430 ? "4px" : "9px", 
              },
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            fontWeight:cell.column.id==="ord_identificador"?"bold":"",
          }
        };
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
            fontWeight: "bold",
          },
        };
      }}
    renderRowActions={({ row,table }) => {
      return <Box className="d-flex">
        <IconButton onClick={() => { selectItemOrdenes({ ordd_identificador: row.original.ord_identificador })}}>
          <AddBoxIcon/>
        </IconButton>
        <IconButton onClick={() => { deleteRow({row:row.original});}}  color="error">
          <DeleteIcon/>
        </IconButton>
        </Box>
      }}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      initialState={{
        pagination: { pageSize: window.innerWidth<=611?30 :30 , pageIndex: 0 }
      }}
      globalFilterFn="contains"
      positionGlobalFilter="left"
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "66dvh":"70dvh":"72dvh" : "57dvh" } }}//370w 420w, 611w, desktop
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={false}
      enableRowActions={true}
      enablePagination={true}
      enableSorting={true}
      enableFilters={true}
      enableDensityToggle={false}
      enableTopToolbar={true}
      columns={COLUMNS_LISTA_ORDENES_NORMAL()}
      data={dataListOrdenes}
    />
  );
}
function DATATABLE_COTIZACION({
  dataCotizacion,
  onClickDeleteCotizacion_sts,
  setBasicModalEdit,
  setBasicModal,
  setFormCotCotizacion,
  fetchCotdDetalle,
  setFormClientes,
  setPrintI,
  onClickNuevaCotizacion,
  fetch_cot_cotizacion,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      initialState={{
        pagination: { pageSize: 50, pageIndex: 0 },
      }}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: window.innerWidth <= 370?105:window.innerWidth <= 620?85:120,
          maxSize: window.innerWidth <= 370?105:window.innerWidth <= 620?85:120,
          minSize: window.innerWidth <= 370?105:window.innerWidth <= 620?85:120,
          muiTableBodyCellProps: {
            sx: {
              display: "flex",
              justifyContent: "center",
              // width:"100px",
              alignItems: "center",
              "& button": {
                marginX:  window.innerWidth <= 430 ? "0px" : "9px", 
              },
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={true}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={true}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      // muiTableContainerProps={{ sx: { maxHeight: "74vh" } }}
        muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "73dvh":"75dvh":"80dvh" : "65dvh" } }}//370w 420w, 611w, desktop
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      columns={COLUMNS_COT_COTIZACION}
      data={dataCotizacion}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      renderRowActions={({ row }) => {
        return (
          <Box className="d-flex">
            <IconButton
              color="error"
              onClick={() =>
                onClickDeleteCotizacion_sts({
                  cot_id: row.original.cot_id,
                  cot_status: 0,
                })
              }
            >
              <DeleteIcon />
            </IconButton>
            <IconButton
              onClick={() => {
                setBasicModalEdit(true);
                setBasicModal(true);
                setFormCotCotizacion({
                  cot_id: row.original.cot_id,
                  cot_identificador: row.original.cot_identificador,
                  cot_cliente: row.original.cot_cliente,
                  cot_nombre: row.original.cli_nombre,
                  cot_fecha: moment(new Date(row.original.cot_fecha)).format(
                    "YYYY-MM-DD"
                  ),
                  cot_vendedor: row.original.cot_vendedor,
                  cot_status: row.original.cot_status,
                  cot_garantia: row.original.cot_garantia,
                  cot_garantia_name: row.original.cot_garantia_name,
                  cot_descripcion: row.original.cot_descripcion,
                });
                fetchCotdDetalle(row.original.cot_identificador);
                setFormClientes({
                  cli_id: row.original.cot_cliente,
                  cli_nombre: row.original.cli_nombre,
                  cli_ruc: row.original.cli_ruc,
                });
              }}
            >
              <EditIcon />
            </IconButton>
            <IconButton
              onClick={() => {
                setPrintI(true);
                setFormCotCotizacion({
                  cot_id: row.original.cot_id,
                  cot_identificador: row.original.cot_identificador,
                  cot_cliente: row.original.cot_cliente,
                  cot_nombre: row.original.cli_nombre,
                  cli_ruc: row.original.cli_ruc,
                  cli_telefono: row.original.cli_telefono,
                  cot_fecha: row.original.cot_fecha,
                  cot_vendedor: row.original.cot_vendedor,
                  cot_status: row.original.cot_status,
                  cot_descripcion: row.original.cot_descripcion,
                  cot_garantia: row.original.cot_garantia,
                  cot_garantia_name: row.original.cot_garantia_name,
                  cot_vendedor_name: row.original.usr_nombre,
                });
                fetchCotdDetalle(row.original.cot_identificador);
              }}
            >
              <LocalPrintshopIcon />
            </IconButton>
            {row.original.art_img === "1" ? (
              <img
                className="img-art-datatable"
                alt=""
                src={imgURLocalImage + row.original.art_imgName}
              />
            ) : null}
          </Box>
        );
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      muiTableBodyCellProps={({ cell }) => {
        return {
          sx: {
            textAlign:
              cell.column.id === "mrt-row-actions" ||
              cell.column.id === "cot_id" ||
              cell.column.id === "cot_fecha" ||
              cell.column.id === "cotd_total"
                ? "center"
                : "left",
          },
        };
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box>
          <IconButton
            onClick={() => {
              onClickNuevaCotizacion();
            }}
          >
            <AddBoxIcon />
          </IconButton>
          <IconButton onClick={() => fetch_cot_cotizacion()}>
            <CachedIcon />
          </IconButton>
        </Box>
      )}
    />
  );
}
function DATATABLE_LISTA_CLIENTE({
  dataCliente,
  selectCliente,
  setTabClientes,
  handleSaveRow,
}) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "66dvh":"70dvh":"73dvh" : "85dvh" } }}//370w 420w, 611w, desktop
         initialState={{
            pagination: { pageSize: window.innerHeight>=1000?30: 15, pageIndex: 0 }
          }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: window.innerWidth <= 370?105:95,
          maxSize: window.innerWidth <= 370?105:95,
          minSize: window.innerWidth <= 370?105:95,
          muiTableBodyCellProps: {
            sx: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}
      muiPaginationProps={{
        showRowsPerPage: false
      }}
      globalFilterFn="contains"
      layoutMode="grid"
      enableEditing={false}
      enableColumnActions={false}
      editDisplayMode="modal"
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableRowActions={false}
      positionActionsColumn="last"
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableStickyHeader={true}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      onEditingRowSave={handleSaveRow}
      columns={COLUMNS_LISTA_CLIENTE()}
      data={dataCliente}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      muiTableBodyRowformFactura={({ row }) => {
        return {
          sx: {
            backgroundColor:
              row.original.re_fecha_procesado !== "0000-00-00 00:00:00"
                ? "rgba(219, 237, 220, 0.78)"
                : "",
            fontWeight: "bold",
          },
        };
      }}
      muiTableBodyRowProps={({ row }) => {
        return {
          onClick: () => {
            selectCliente(row);
            setTabClientes(false);
          },
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
    />
  );
}
function DATATABLE_COLUMNS_RENCUENTO({ enableTab, dataRecuentoDetalle, handleSaveRow, deleteRow }) {
  return (
    <MaterialReactTable
      paginationDisplayMode="default"
      muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "38dvh":"45dvh":"50dvh" : "65dvh" } }}//370w 420w, 611w, desktop
      initialState={{
        columnVisibility: {
          fcd_descuento_number: false,
          red_cantidad: window.innerWidth <= 611 ? false : true,
          art_upc: window.innerWidth <= 611 ? false : true,
          art_descripcion: window.innerWidth <= 611 ? false : true,
        },
      }}
      layoutMode="grid"
      editDisplayMode="modal"
      enableBottomToolbar={true}
      muiSearchTextFieldProps={{
        placeholder: "Buscar",
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "OPCIONES",
          size: window.innerWidth <= 370?75:55,
          maxSize: window.innerWidth <= 370?75:55,
          minSize: window.innerWidth <= 370?75:55,
          muiTableBodyCellProps: {
            sx: {
              display: "flex",
              justifyContent: "center",
              width:"70px",
              alignItems: "center",
              "& button": {
                marginX:  window.innerWidth <= 430 ? "4px" : "9px", 
              },
            },
          },
          muiTableHeadCellProps: {
            sx: {
              textAlign: "center",
            },
          },
        },
      }}
      renderRowActions={({ row, table }) => (
        <Box>
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
          <IconButton onClick={() => deleteRow(row)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      )}
      renderEditRowDialogContent={({ table, row, internalEditComponents }) => (
        <>
          <DialogTitle variant="h5">Editar fila</DialogTitle>
          <DialogContent sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
            {internalEditComponents} {/* or render custom edit components here */}
          </DialogContent>
          <DialogActions>
            <MrtEditActionButtons variant="icon" table={table} row={row} />
          </DialogActions>
        </>
      )}
      muiTableBodyRowProps={({ row }) => {
        return {
          sx: {
            backgroundColor: row.id % 2 === 0 ? "#f0f0f0" : "",
          },
        };
      }}
      renderEmptyRowsFallback={() => (
        <Col xs={12} className="col-no-record">
          <Label className="label-no-record">No hay registros que mostrar</Label>
        </Col>
      )}
      muiPaginationProps={{
        showRowsPerPage: false,
      }}
      globalFilterFn="contains"
      enableStickyHeader={true}
      positionActionsColumn="last"
      enableGlobalFilter={true}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableEditing={true}
      enableRowActions={true}
      enablePagination={true}
      enableSorting={false}
      enableFilters={true}
      enableDensityToggle={false}
      positionGlobalFilter="left"
      enableTopToolbar={true}
      data={enableTab ? [] : dataRecuentoDetalle}
      onEditingRowSave={handleSaveRow}
      columns={COLUMNS_RE_RECUENTO_DETALLE()}
    />
  );
}
export {
  DATATABLE_ENTRADA_FACTURA_COMPRA,
  DATATABLE_ENTRADA_INVENTARIO,
  DATATABLE_SALIDA_VENTA,
  DATATABLE_MOVIMIENTO_INVENTARIO,
  DATATABLE_COLUMNS_MOVIMIENTO,
  DATATABLE_COLUMNS_LISTA_ORDENES_NORMAL,
  DATATABLE_PUBLICIDAD,
  DATATABLE_DESCUENTO,
  DATATABLE_GARANTIA,
  DATATABLE_COLUMNS_LISTA_ORDENES,
  DATATABLE_RESTAURANTE,
  DATATABLE_CREDITOS_PAGO,
  DATATABLE_CREDITOS,
  DATATABLE_COLUMNS_LISTA_CREDITOS_PAGO,
  DATATABLE_COLUMNS_LISTA_CREDITOS_DETALLE,
  DATATABLE_COLUMNS_RENCUENTO,
  DATATABLE_COLUMNS_LISTA_COTIZACION,
  DATATABLE_COLUMNS_LISTA_FPAGO,
  DATATABLE_COLUMNS_LISTA_ANULACION,
  DATATABLE_DC_COMPRA_DETALLE,
  DATATABLE_COLUMNS_LISTA_ITEMS,
  DATATABLE_LISTA_ITEMS2,
  DATATABLE_INV_INVENTARIO,
  DATATABLE_DC_COMPRA,
  DATATABLE_TRAZABILIDAD,
  DATATABLE_ARTICULO,
  DATATABLE_APARTADO,
  DATATABLE_CATEGORIAS,
  DATATABLE_USUARIOS,
  DATATABLE_MARCAS,
  DATATABLE_PROVEEDORES,
  DATATABLE_CLIENTES,
  DATATABLE_FACTURA,
  DATATABLE_COTIZACION,
  DATATABLE_LISTA_CLIENTE,
  DATATABLE_LISTA_ITEMS,
  DATATABLE_COTIZACION_DETALLE,
  DATATABLE_BODEGAS,
  DATATABLE_COLUMNS_LISTA_CREDITOS,
  DATATABLE_EXSITENCIA_INVENTARIO,
  DATATABLE_COLUMNS_LISTA_ITEMS_BODEGA,
  DATATABLE_CLIENTES_REPORTE,
  DATATABLE_CLIENTES_HISTORIAL,
  DATATABLE_GASTOS
};
